import { useEffect, useState } from 'react';

import { getAskFields, setAskFields } from '../api';
import { MiscellaneousData, UseProductAgreement } from './types';
import { useNotifications } from './useNotifications';

export const useMiscellaneousData = (projectId: string): UseProductAgreement => {
  const [fetching, setFetching] = useState<boolean>(true);
  const [error, setError] = useState<boolean>(false);
  const { showErrorNotify } = useNotifications();

  const [data, setData] = useState<MiscellaneousData>([]);

  const fetchData = async () => {
    try {
      const response = await getAskFields(projectId);
      setData(response);
    } catch (err) {
      showErrorNotify(err);
      setError(true);
    } finally {
      setFetching(false);
    }
  };

  const updateData = async (values: MiscellaneousData) => {
    try {
      setData(values);
      await setAskFields(projectId, values);
    } catch (err) {
      showErrorNotify(err);
      setError(true);
    } finally {
      setFetching(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  return {
    miscellaneousFetching: fetching,
    miscellaneousError: error,
    miscellaneousData: data,
    updateMiscellaneous: updateData
  };
};
